var root = process.env.API_ROOT;
export default {
    // 基础模块
    get_menu: root.logismg_service + 'base/selectAllMenus', // 菜单列表
    add_menu: root.logismg_service + 'base/menu/', // 新增菜单
    update_menu: root.logismg_service + 'base/menu/', // 更新菜单
    del_menu: root.logismg_service + 'base/menu/', // 删除菜单
    get_oper: root.logismg_service + 'base/selectAllOpers', // 权限列表
    add_oper: root.logismg_service + 'base/oper/save', // 新增权限
    update_oper: root.logismg_service + 'base/oper/update', // 更新权限
    del_oper: root.logismg_service + 'base/oper/delete', // 删除权限
    ebay_auth: root.logismg_service + 'ebayAccount/authUrl/', // +{ebayAccountId} ebay授权
    binding_ebayaccount: root.logismg_service + 'ebayAccount', // 添加账号绑定
    get_singlePageRole: root.logismg_service + 'userInfo/queryOperByMenu/', // 获取单页权限
    get_userInfo: root.logismg_service + 'userInfo/getAllUser', // 获取用户信息
    logout: root.logismg_service + 'logout/', // 登出
    get_commonParameter: root.logismg_service + 'base/commonParameter/list', // 顶级CommonParameter查询
    // 权限控制
    get_menuRole: root.logismg_service + 'userInfo/', // 查询用户菜单
    // 设置模块
    get_token: root.logismg_service + 'auth/', // get token
    refresh_token: root.logismg_service + 'refresh/',
    token_time: 540000, // token生存时间
    login:'https://passport.staging-164.tongtool.com/?u=',

    // 物流商模块
    // 个人中心
    get_memberInfo: root.logismg_service + 'logis/carrier/member/info', // 查询公司信息
    edit_memberInfo: root.logismg_service + 'logis/carrier/member/modify', // 修改公司信息
    get_yesterdayInfo: root.logismg_service + 'logis/carrier/member/queryInfo', // 昨天包裹数量和占比
    get_monthInfo: root.logismg_service + 'logis/carrier/member/queryDateInfo', // 近30天包裹数量
    uploadImg: root.logismg_service + 'logis/carrier/member/upload', // 上传图片
    auditPartner: root.logismg_service + 'logis/carrier/member/auditPartner', // 审核物流商
    getUserAuth:root.logismg_service + 'logis/carrier/member/userAuth', // 获取当前用户ID

    // 运单号管理
    get_trackingListPage: root.logismg_service + 'logis/carrier/tracking/listPage', // 查询客户运单信息
    get_trackingInfo: root.logismg_service + 'logis/carrier/tracking/info', // 查询客户渠道与跟踪信息
    add_trackingNumber: root.logismg_service + 'logis/carrier/tracking/save', // 保存跟踪号
    import_tracking: root.logismg_service + 'logis/carrier/tracking/import', // 导入跟踪号模型

    // 包裹管理
    get_packageList: root.logismg_service + 'logis/carrier/package/listPage', // 包裹列表
    get_shipMethod: root.logismg_service + 'logis/carrier/package/shipping_method_list', // 渠道列表
    getPackageInfo:root.logismg_service + 'logis/carrier/package/getInfo',
    statisticsPackageInfo:root.logismg_service + 'logis/carrier/package/statisticsPackageInfo',// 统计包裹信息
    queryPackageList:root.logismg_service + 'logis/carrier/package/queryPackageList',// 查询包裹信息
    queryPackageStatisticsList:root.logismg_service + 'logis/carrier/package/queryPackageStatisticsList',// 查询包裹统计信息

    // 客户分析
    get_analyze: root.logismg_service + 'logis/carrier/analyze/listPage', // 查询客户信息

    // 客户管理
    get_managerList: root.logismg_service + 'logis/carrier/manager/listPage', // 物流商客户
    get_message: root.logismg_service + 'logis/carrier/manager/info', // 客户基本信息
    get_shipping: root.logismg_service + 'logis/carrier/manager/shipping/listPage', // 渠道信息

    // 旧的渠道管理
    get_params: root.logismg_service + 'logis/carrier/shipping/def_param', // 动态参数
    edit_shipStatus: root.logismg_service + 'logis/carrier/shipping/edit', // 修改渠道状态
    get_shippingInfo: root.logismg_service + 'logis/carrier/shipping/info', // 渠道详情
    get_shipListPage: root.logismg_service + 'logis/carrier/shipping/listPage', // 渠道列表
    del_zone: root.logismg_service + 'logis/carrier/shipping/remove_zone', // 删除分区
    add_shipping: root.logismg_service + 'logis/carrier/shipping/save', // 保存渠道
    updatePriceModel: root.logismg_service + 'logis/carrier/shipping/update', // 更新计费模型

    // 新的渠道管理
    get_params2ver: root.logismg_service + 'logis/carrier/shipping2ver/def_param', // 动态参数列表
    edit_shipStatus2ver: root.logismg_service + 'logis/carrier/shipping2ver/edit', // 修改渠道状态
    upload_excel2ver: root.logismg_service + 'logis/carrier/shipping2ver/import', // 导入计费模型模板
    get_shippingInfo2ver: root.logismg_service + 'logis/carrier/shipping2ver/detail', // 渠道详情
    get_shipListPage2ver: root.logismg_service + 'logis/carrier/shipping2ver/listPage', // 渠道列表
    del_zone2ver: root.logismg_service + 'logis/carrier/shipping2ver/remove_zone', // 删除分区
    add_shipping2ver: root.logismg_service + 'logis/carrier/shipping2ver/save', // 保存渠道
    updatePriceModel2ver: root.logismg_service + 'logis/carrier/shipping2ver/update', // 保存更新计费模型
    updatePriceModeZone2ver: root.logismg_service + 'logis/carrier/shipping2ver/updatePriceModelZone', // 编辑计费模型保存
    savePriceModel2ver: root.logismg_service + 'logis/carrier/shipping2ver/savePriceModel', // 新增计费模型保存
    queryPriceZoneDtl2ver: root.logismg_service + 'logis/carrier/shipping2ver/queryPriceModelZoneDetail', // 计费模型分区详情
    warehouse_owarehouseList:root.logismg_service + 'logis/carrier/shipping2ver/owarehouseList', // 海外仓渠道查询
    warehouse_queryOwarehouseDetail:root.logismg_service + 'logis/carrier/shipping2ver/queryOwarehouseDetail', // 海外仓渠道详情查询
    warehouse_saveOwarehosue:root.logismg_service + 'logis/carrier/shipping2ver/saveOwarehosue', // 保存海外仓渠道
    warehouse_modifyOwareStatus:root.logismg_service + 'logis/carrier/shipping2ver/modifyOwareStatus', // 更新海外仓渠道状态
    warehouse_queryWarehouseList:root.logismg_service + 'logis/carrier/shipping2ver/queryWarehouseList', // 查询所有仓库信息
    upload_shippingMethod: root.logismg_service + 'logis/carrier/shipping2ver/importShippingMethod', // 导入计费模型模板

    //仓库管理
    warehouse_getList: root.logismg_service + 'logis/warehouse/queryWarehouses', // 仓库列表
    warehouse_modifyStatus: root.logismg_service + 'logis/warehouse/modifyStatus', // 修改仓库状态
    warehouse_save:root.logismg_service + 'logis/warehouse/saveWarehouse', // 保存仓库状态
    warehouse_getDetail: root.logismg_service + 'logis/warehouse/queryWarehouseDetail', // 渠道详情
    warehouse_menuStatus:root.logismg_service + 'logis/warehouse/queryMenuStatus', // 菜单状态

    admin_queryWarehouses:root.logismg_service + 'logis/warehouse_admin/queryWarehouses', // 管理员查询仓库
    admin_saveWarehouse:root.logismg_service + 'logis/warehouse_admin/saveWarehouse', // 管理员保存仓库
    admin_modifyStatus:root.logismg_service + 'logis/warehouse_admin/modifyStatus', // 管理员更新仓库状态
    admin_updateCheckStatus:root.logismg_service + 'logis/warehouse_admin/updateCheckStatus', // 管理员更新仓库状态
    admin_deleteWarehouse:root.logismg_service + 'logis/warehouse_admin/deleteWarehouse', // 管理员更新仓库状态

    // 渠道管理[admin]
    get_logisticProviderList: root.logismg_service + 'logis/carrier/logis_admin/carrier_listPage', // 物流商列表
    get_channelList: root.logismg_service + 'logis/carrier/logis_admin/shipping_listPage', // 物流商渠道列表
    get_shipInfo: root.logismg_service + 'logis/carrier/logis_admin/priceDetail', // 计费模型详情
    update_priceModel: root.logismg_service + 'logis/carrier/logis_admin/update', // 更新计费模型
    upload_excel: root.logismg_service + 'logis/carrier/shipping/import', // 导入模板
    get_defparams: root.logismg_service + 'logis/carrier/logis_admin/def_param',//动态参数列表
    saveOrUpdate_shipping:root.logismg_service + 'logis/carrier/logis_admin/saveOrUpdate', // 保存或更新渠道
    edit_shippingStatus: root.logismg_service + 'logis/carrier/logis_admin/updateStatus', // 修改渠道启用状态
    edit_checkStatus: root.logismg_service + 'logis/carrier/logis_admin/updateCheckStatus', // 修改渠道审核状态
    del_shippingmethod: root.logismg_service + 'logis/carrier/logis_admin/delshippingmethod', // 删除渠道

    admin_queryOwShippingList:root.logismg_service + 'logis/carrier/logis_admin/owShippingList', // 查询海外仓渠道列表
    admin_updateOwStatus:root.logismg_service + 'logis/carrier/logis_admin/updateOwStatus', // 更新海外仓渠道状态
    admin_updateOwCheckStatus:root.logismg_service + 'logis/carrier/logis_admin/updateOwCheckStatus', // 审核海外仓渠道
    admin_delowshippingmethod:root.logismg_service + 'logis/carrier/logis_admin/delowshippingmethod', // 删除海外仓渠道
    admin_saveOwShippingMethod:root.logismg_service + 'logis/carrier/logis_admin/saveOwShippingMethod', // 保存海外仓渠道
    admin_getCheckStatus:root.logismg_service + 'logis/carrier/logis_admin/queryCheckStatus', // 查询是否需要审核
    admin_saveCheckStatus:root.logismg_service + 'logis/carrier/logis_admin/saveCheckStatus', // 更新是否需要审核
    admin_queryLabelList:root.logismg_service + 'logis/carrier/logis_admin/queryLabelList', // 查询当前渠道已启用的自制模板列表
    admin_queryLabelTemplates:root.logismg_service + 'logis/carrier/logis_admin/queryLabelTemplates', // 查询模板列表
    admin_saveCustomTemplate:root.logismg_service + 'logis/carrier/logis_admin/saveCustomTemplate', // 保存定制模版信息
    admin_initExtendInfo:root.logismg_service + 'logis/carrier/logis_admin/initExtendInfo', // 初始化渠道扩展信息

    // 管理员访问管理
    admin_accessStatistics_list:root.logismg_service + 'logis/admin/accessStatistics/queryList', // 查询访问列表
    admin_queryStatisticsList:root.logismg_service + 'logis/admin/accessStatistics/queryStatisticsList', // 查询访问统计
    admin_accessStatistics_detail:root.logismg_service + 'logis/admin/accessStatistics/queryDetail', // 查询访问详情

    // 物流商访问管理
    accessStatistics_list:root.logismg_service + 'logis/carrier/accessStatistics/queryList', // 查询访问列表
    accessStatistics_detail:root.logismg_service + 'logis/carrier/accessStatistics/queryDetail', // 查询访问详情

    // 基础数据
    get_countrys: root.logismg_service + 'logis/base/country', // 国家
    get_province: root.logismg_service + 'logis/base/province', // 省份
    get_city: root.logismg_service + 'logis/base/city', // 城市
    get_queryZoneCountry: root.logismg_service + 'logis/base/queryZoneCountry', // 大洲列表
    get_queryCountryKeyword: root.logismg_service + 'logis/base/queryCountryByKeyword', // 模糊匹配国家列表

    // 卖家模块
    // 卖家个人中心
    get_sellerMemberInfo: root.logismg_service + 'logis/seller/member/info', // 卖家详情
    get_sellerYesterdayInfo: root.logismg_service + 'logis/seller/member/queryInfo', // 昨天包裹数量与占比
    get_nearlyMonthInfo: root.logismg_service + 'logis/seller/member/queryDateInfo', // 近30天包裹数量

    // 物流方案查询
    get_countrysNameList: root.logismg_service + 'logis/base/country', // 获取目的国家列表
    get_citysNameList: root.logismg_service + 'logis/base/allCity', // 获取揽收城市列表
    get_logisPlanList: root.logismg_service + 'logis/seller/shipping/listPage', // 获取物流方案列表

    // 物流追踪
    get_platformAndShopList: root.logismg_service + 'tracking/packages/platformAndShop/list', // 获取所有平台和店铺名称
    get_trackCountryList: root.logismg_service + 'tracking/packages/country/list', // 获取物流国家列表
    get_shippingMethodList: root.logismg_service + 'tracking/packages/shippingMethod/list', // 获取物流方式列表
    get_trackList: root.logismg_service + 'tracking/packages/listPage', // 获取物流追踪表格数据
    get_trackStatus: root.logismg_service + 'tracking/packages/status/list', // 查询物流跟踪状态
    get_trackingDtlInfo: root.logismg_service + 'tracking/packages/query', // 物流跟踪详情

    // 物流对账
    get_logisProviderName: root.logismg_service + 'logis/seller/checking/list', // 获取所有物流商名称
    get_logisCheckList: root.logismg_service + 'logis/seller/checking/listPage', // 获取物流对账列表
    import_checkExcel: root.logismg_service + 'logis/seller/checking/import', // 导入excel
    export_checkExcel: root.logismg_service + 'logis/seller/checking/export', // 导出excel
    import_billExcel: root.logismg_service + 'logis/seller/checking/importBill', // 导入物流账单
    get_billListData: root.logismg_service + 'logis/seller/checking/queryBillList', // 账单管理列表
    updatePayStatus: root.logismg_service + 'logis/seller/checking/updatePaymentStatus', //  更新付款状态

    // 我的物流商
    get_carrierName: root.logismg_service + 'logis/seller/analyze/carrier/list', // 获取所有物流商名称
    get_carrierList: root.logismg_service + 'logis/seller/analyze/carrier/listPage', // 我的物流商列表
    export_carrierExcel: root.logismg_service + 'logis/seller/analyze/carrier/export', // 导出excel

    // 我的物流渠道分析
    get_shippingList: root.logismg_service + 'logis/seller/analyze/shipping/listPage', // 我的物流渠道列表
    export_shipExcel: root.logismg_service + 'logis/seller/analyze/shipping/export', // 导出excel

    // 物流详情
    get_logisProviderList: root.logismg_service + 'logis/seller/carrier/details/listPage', // 获取物流商列表
    get_logisDtlInfo: root.logismg_service + 'logis/seller/carrier/details/shipping/info', // 获取物流渠道详情
    get_logisShippingList: root.logismg_service + 'logis/seller/carrier/details/shipping/listPage', // 获取物流渠道列表
    upload_shippingExcel: root.logismg_service + 'logis/seller/carrier/details/shipping2ver/import', // 导入计费模型
    get_logisDtl2verInfo: root.logismg_service + 'logis/seller/carrier/details/shipping2ver/info', // 渠道详情
    get_queryPriceModelZoneDetail: root.logismg_service + 'logis/seller/carrier/details/shipping2ver/queryPriceModelZoneDetail', // 渠道详情—计费模型分区详情
    saveSellerPriceModel: root.logismg_service + 'logis/seller/carrier/details/shipping2ver/savePriceModel', // 新增计费模型分区保存
    updateSellerPriceModelZone: root.logismg_service + 'logis/seller/carrier/details/shipping2ver/updatePriceModelZone', // 编辑计费模型分区保存
    isAbledPriceModel: root.logismg_service + 'logis/seller/carrier/details/shipping2ver/freightModelState', // 启用或停用计费模型

    // 海外仓接口
    get_overseaWarehouses: root.logismg_service + 'lbasedataapi/getOverseaWarehouses', // 获取海外仓数据
    get_overseaShipMethods: root.logismg_service + 'lbasedataapi/getOWarehouseShippingMethods', // 获取当前海外仓对应的物流渠道


    sendMobileCode:root.logismg_service + 'logis/carrier/member/sendMobileCode',// 发送验证码
    userIsExist:root.logismg_service + 'logis/carrier/member/checkUser',// 校验用户是否存在
    checkMobileCode:root.logismg_service + 'logis/carrier/member/checkMobileCode',// 校验手机验证码
    checkEmailCode:root.logismg_service + 'logis/carrier/member/checkEmailCode',// 校验邮箱验证码
    findPassword:root.logismg_service + 'logis/carrier/member/findPassword',// 找回密码
    sendEmailCode:root.logismg_service + 'logis/carrier/member/sendEmailCode',// 发送邮箱验证码
    saveUser:root.logismg_service + 'logis/carrier/member/register',// 注册
    resetPassword:root.logismg_service + 'logis/carrier/member/resetPassword',// 重置密码
    getInfoByParam:root.logismg_service + 'logis/carrier/member/getInfoByParam',// 查询合作伙伴列表
    saveCarrierParam:root.logismg_service + 'logis/carrier/saveCarrierParam',//保存物流API参数
    getAllCarrierParam:root.logismg_service + 'logis/carrier/all_def_param',//查询所有物流API参数
    api_param:root.logismg_service + 'logis/carrier/member/api_param',//保存物流API参数
    carrierAccount:root.logismg_service + 'logis/carrier/member/carrierAccount',//查询物流商账号信息
    addAccount:root.logismg_service + 'logis/carrier/member/addAccount',//添加物流商账号
    updateAccount:root.logismg_service+ 'logis/carrier/member/updateAccount',// 更新账号
    updatePassword:root.logismg_service+ 'logis/carrier/member/updatePassword',// 更新密码
    platform_param:root.logismg_service + 'logis/carrier/member/platform_param',//物流系统动态参数
    syncApiParam:root.logismg_service + 'logis/carrier/member/syncApiParam',//同步API参数
    saveCarrier:root.logismg_service + 'logis/carrier/saveCarrier',//保存物流信息
    activeCarrier:root.logismg_service + 'logis/carrier/member/activeList',//获取有效物流商

    getLogInfo:root.logismg_service + 'logisapi/log/query',// 查询日志报文
};


// WEBPACK FOOTER //
// ./src/api/api.js